import { newOrderObject } from '@/app/Order';
import { GQL_recurringOrder_recurringOrder } from '@/queries/__generated__/recurringOrder';
import dayjs from '@/utils/dayjs';

export const recurrenceIntervals = [
  '1.day',
  '1.week',
  '2.weeks',
  '4.weeks',
  '1.month',
  '3.months',
  '4.months',
  '1.year',
];

export const newRecurringOrderObject: (() => GQL_recurringOrder_recurringOrder) = () => {
  return {
    ...newOrderObject(),
    __typename: 'RecurringOrder',
    recurringOrderSetting: {
      __typename: 'RecurringOrderSetting',
      id: '',
      active: true,
      startDate: dayjs().format('YYYY-MM-DD'),
      endDate: null,
      dateOffset: 0,
      interval: '',
      lastDateCreatedOn: null,
    },
  };
};

export const formatRecurringOrderDataForMutation = (data: { order: GQL_recurringOrder_recurringOrder }) => {
  return {
    ...data.order,
    recurringOrderSetting: {
      ...data.order.recurringOrderSetting,
      id: data.order.recurringOrderSetting.id || null,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      dateOffset: parseInt(data.order.recurringOrderSetting.dateOffset as any),
      lastDateCreatedOn: undefined,
    },
    unit: undefined,
    unitId: data.order.unit.id,
    customer: undefined,
    customerId: data.order.customer.id,
    car: undefined,
    carId: data.order.car?.id || null,
    project: undefined,
    projectId: data.order.project?.id || null,
    department: undefined,
    departmentId: data.order.department?.id || null,
    accountingCost: undefined,
    supplierParty: {
      ...data.order.supplierParty,
      country: undefined,
      countryCode: data.order.supplierParty.country.code,
    },
    customerParty: {
      ...data.order.customerParty,
      country: undefined,
      countryCode: data.order.customerParty.country.code,
    },
    orderDelivery: {
      ...data.order.orderDelivery,
      country: undefined,
      countryCode: data.order.orderDelivery.country.code,
    },
    orderLines: data.order.orderLines.map(line => {
      return {
        ...line,
        $_UID: undefined,
        $_page: undefined,
        $_expanded: undefined,
        product: undefined,
        productId: line.product?.id || null,
        car: undefined,
        carId: line.car?.id || null,
        project: undefined,
        projectId: line.project?.id || null,
        department: undefined,
        departmentId: line.department?.id || null,
        accountingCost: undefined,
      };
    }),
    orderAllowanceCharges: data.order.orderAllowanceCharges.map(ac => {
      return {
        ...ac,
        orderAllowanceChargeLines: ac.orderAllowanceChargeLines.map(acl => {
          return {
            ...acl,
          };
        }),
      };
    }),
  };
};
